<template>
  <div class="breadcrumbs-container section-container" :class="{'dark':skinType}">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(breadcrumb, index) of breadcrumbs"
        :to="{
          path: breadcrumb.routeName,
          params: {
            equipId: '',
          },
        }"
        :replace="true"
        :key="'breadcrumb' + index"
      >
        {{ breadcrumb.title }}</el-breadcrumb-item
      >
    </el-breadcrumb>
  </div>
</template>
<script>
export default {
  name: 'breadcrumbs',
  props: {
    selectNode: {
      type: Object,
      default() {
        return {};
      },
    },
    nodeList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      breadcrumbs: [],
    };
  },
  watch: {
    selectNode() {
      this.breadcrumbs = this.getBreadcrumbsData(this.nodeList);
    },
    nodeList() {
      this.breadcrumbs = this.getBreadcrumbsData(this.nodeList);
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    getBreadcrumbsData(nodeList) {
      const selectProject = this.getSelectProject(nodeList);
      const pathArr = this.getBreadcrumbsLevelData(selectProject);
      const breadcrumbs = [];
      for (let i = 0; i < pathArr.length; i += 1) {
        const path = pathArr[i];
        breadcrumbs.push({
          title: path.ModelName,
        });
      }
      return breadcrumbs;
    },
    getBreadcrumbsLevelData(parentNode) {
      let arr = [];
      if (parentNode != null) {
        arr.push(parentNode);
        if (!parentNode.Children) {
          return arr;
        }
        for (let i = 0; i < parentNode.Children.length; i += 1) {
          if (this.isProjectHasNode(parentNode.Children[i])) {
            arr = [...arr, ...this.getBreadcrumbsLevelData(parentNode.Children[i])];
            break;
          }
        }
      }
      return arr;
    },
    getSelectProject(nodeList) {
      for (let i = 0; i < nodeList.length; i += 1) {
        if (this.isProjectHasNode(nodeList[i])) {
          return nodeList[i];
        }
      }
      return null;
    },
    isProjectHasNode(nodeInfo) {
      if (nodeInfo === null || this.selectNode === null) {
        return false;
      }
      if (nodeInfo.IdStr === this.selectNode.IdStr) {
        return true;
      }
      if (!nodeInfo.Children) {
        return false;
      }
      for (let i = 0; i < nodeInfo.Children.length; i += 1) {
        if (this.isProjectHasNode(nodeInfo.Children[i])) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
